module.exports = __webpack_public_path__ + "static/media/sf_hotel_13.272ffe44.jpg";